import { useQuery } from '@tanstack/react-query';
import { getTwoFactorIdentities } from '../requests';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { useSessionStore } from '@/entities/session';

export const useTwoFactorAuthIdentities = () => {
  const { session } = useSessionStore();

  const { data, isLoading, error } = useQuery({
    queryKey: ['user-profile-two-factor-settings', session?.userId],
    queryFn: getTwoFactorIdentities,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    enabled: !!session?.userId,
  });

  return {
    twoFactorAuthIdentities: data,
    isTwoFactorAuthIdentitiesLoading: isLoading,
    twoFactorAuthIdentitiesError: error,
  };
};
